import { push } from "connected-react-router"
import {
    ExclusiveChoiceDropdown,
    ExclusiveChoiceDropdownProps,
    IconAccount
} from "dash-styled"
import React, { useCallback, useMemo, FC } from "react"
import { useDispatch } from "react-redux"
import { selectUser } from "../../../Helpers/Functions/Selectors/auth"
import { useOrgs } from "../../../Hooks/useOrgs"
import { useAppState } from "../../../Hooks/useReduxState"
import { APIOrgMember } from "../../../Models/API/APIOrgMember"
import { hasValue } from "../../../Models/Client/FetchState"
import { Result } from "../../../Models/Utility/Result"
import { routePaths } from "../../../Routes"
import { ReactComponent as TeamIcon } from "icons/lib/team.svg"

export const OrgChooser: FC<
    Omit<
        ExclusiveChoiceDropdownProps<APIOrgMember | undefined>,
        | "choices"
        | "value"
        | "renderChoice"
        | "onClick"
        | "placeholder"
        | "disabledChoices"
    > & { selectedOrgUsername: string }
> = props => {
    const dispatch = useDispatch()
    const orgsFetch = useOrgs()
    const handleChangeOrg = useCallback(
        (orgUsername: string) =>
            dispatch(push(routePaths.orgHome(orgUsername))),
        [dispatch]
    )
    const me = useAppState(selectUser)
    const orgChoicesFetch = useMemo(
        () =>
            hasValue(orgsFetch)
                ? me === undefined
                    ? undefined
                    : Result.ok(
                          [me.username].concat(
                              orgsFetch.value.map(org => org.orgUsername)
                          )
                      )
                : orgsFetch,
        [me, orgsFetch]
    )
    const iconCls = "inline-block w-4 h-4 mr-1 text-rhino-700"
    const renderChoice = useCallback(
        (choice: string) =>
            choice === me?.username ? (
                <>
                    <IconAccount className={iconCls} />
                    Personal account
                </>
            ) : (
                <>
                    <TeamIcon className={iconCls} />
                    {choice}
                </>
            ),
        [me]
    )

    if (!hasValue(orgChoicesFetch) || me === null) {
        return null
    }

    return (
        <ExclusiveChoiceDropdown<string>
            {...props}
            placeholder="Not selected"
            choices={orgChoicesFetch.value}
            value={props.selectedOrgUsername}
            renderChoice={renderChoice}
            onClick={handleChangeOrg}
        />
    )
}
